import { initContract } from '@ts-rest/core';
import { z } from 'zod';

import { FeatureFlagLookup } from '@eluve/graphql-types';
import { FeatureFlagKeysLookup } from '@eluve/posthog';

const c = initContract();

const featureFlagKeysEnum = z.nativeEnum(FeatureFlagKeysLookup);

const TestPosthogFeatureFlagRequestSchema = z.object({
  tenantId: z.string().uuid(),
  userId: z.string().uuid(),
  flagName: featureFlagKeysEnum,
});

const TestPosthogFeatureFlagResponseSchema = z.object({
  flagName: z.string(),
  isEnabled: z.boolean(),
  payload: z.unknown().optional(),
  parsedSuccessfully: z.boolean(),
  tenantName: z.string(),
  userEmail: z.string(),
});

const SetTenantFeatureFlagRequestSchema = z.object({
  tenantId: z.string().uuid(),
  flag: z.nativeEnum(FeatureFlagLookup),
  isEnabled: z.boolean(),
});

const SetTenantFeatureFlagResponseSchema = z.object({
  tenantId: z.string().uuid(),
  flag: z.string(),
  isEnabled: z.boolean(),
  updatedAt: z.string(),
});

export const adminFeatureFlagsContract = c.router(
  {
    testPosthogFeatureFlag: {
      method: 'POST',
      path: '/test-posthog',
      responses: {
        200: TestPosthogFeatureFlagResponseSchema,
      },
      body: TestPosthogFeatureFlagRequestSchema,
      summary: 'Test PostHog feature flag for a specific tenant and user',
    },
    setTenantFeatureFlag: {
      method: 'POST',
      path: '/tenant-flags',
      responses: {
        200: SetTenantFeatureFlagResponseSchema,
      },
      body: SetTenantFeatureFlagRequestSchema,
      summary:
        'Set a tenant feature flag and trigger any associated side-effects',
    },
  },
  {
    pathPrefix: '/admin/feature-flags',
  },
);
